import React from "react";
import bannerImage from "../../assets/About us/Desktop/AboutusBanner.png";
import RoundedArrowButton from "../RoundedArrowButton";

const Banner = () => {
  return (
    <section className="bg-gradient-to-b from-[#E6E7F8] to-[#FFFFFF] pt-20 md:pt-28 pb-16 px-6 md:px-[75px]">
      <div className="">
        {/* Heading - full width */}
        <h1 className="font-garamond-subheading pt-6  text-[#2C3075] leading-tight mb-8 text-center md:text-left">
          Committed to providing High-Quality, Compassionate Care for Healthier
          and Brighter future
        </h1>

        {/* Two-column layout for desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Left Side: Description + Button */}
          <div>
            <p className="font-generalsans-description pt-4 text-[#2C3075] font-normal md:text-[20px] leading-[110%] tracking-normal text-[14px] mb-6">
              At Arambh Rehab, we believe recovery is not just about overcoming
              challenges — it’s about rediscovering life, rebuilding hope, and
              embracing the future with confidence. Our compassionate approach
              blends evidence-based treatments with holistic care, creating a
              safe and supportive environment where healing begins.
            </p>

            {/* <button className="bg-[#E6E7F8] text-[#2C3075] rounded-full px-5 py-2 hover:bg-[#d7d9ea] transition flex items-center space-x-2">
              <span className="font-medium">Contact Us</span>
              <span className="flex items-center justify-center rounded-full bg-[#2C3075] w-6 h-6 text-white">
                →
              </span>
            </button> */}
            <div className="hidden md:block">
              <RoundedArrowButton label="Contact Us" to="/contact" />
            </div>
          </div>

          {/* Right Side: Image */}
          <div className="flex justify-center md:justify-end">
            <img
              src={bannerImage}
              alt="Healthcare team"
              className="rounded-[20px] object-cover w-full max-w-md"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
